import { CompanyUserProductLimits as CompanyUserProductLimitsEntity } from '@treasury/domain/company/user';
import { TmBaseComponent } from '@treasury/presentation';
import { html } from 'lit';
import { customElement, property } from 'lit/decorators.js';

@customElement('tm-company-user-product-limits')
export class CompanyUserProductLimits extends TmBaseComponent {
    @property({ type: Boolean })
    public isReadOnly: boolean = false;

    @property()
    public limits?: CompanyUserProductLimitsEntity;

    public render() {
        return html`<h1 class="text-lg font-bold mb-5">Limits</h1>
            <div class="flex flex-row justify-between gap-5">
                <tm-input
                    .type=${'currency'}
                    class="w-full"
                    ?disabled=${true}
                    .maxLength=${50}
                    .minLength=${1}
                    .name=${'name'}
                    .initial=${this.limits?.productDailyLimit}
                    required
                    showIndicator
                    .label=${'Product Daily Limit'}
                >
                </tm-input>
                <tm-input
                    .type=${'currency'}
                    class="w-full"
                    ?disabled=${this.isReadOnly}
                    .maxLength=${50}
                    .minLength=${1}
                    .name=${'email'}
                    .initial=${this.limits?.pendingProductInitiationLimit}
                    required
                    showIndicator
                    .label=${'Daily Initiation Limit'}
                >
                </tm-input>
                <tm-input
                    .type=${'currency'}
                    class="w-full"
                    ?disabled=${this.isReadOnly}
                    .maxLength=${50}
                    .minLength=${1}
                    .name=${'email'}
                    .initial=${this.limits?.pendingProductApprovalLimit}
                    required
                    showIndicator
                    .label=${'Approval Limit'}
                >
                </tm-input>
            </div> `;
    }
}
